import { render, staticRenderFns } from "./TokenPagesFooter.vue?vue&type=template&id=110a3f82&scoped=true"
import script from "./TokenPagesFooter.vue?vue&type=script&lang=js"
export * from "./TokenPagesFooter.vue?vue&type=script&lang=js"
import style0 from "./TokenPagesFooter.vue?vue&type=style&index=0&id=110a3f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a3f82",
  null
  
)

export default component.exports